module.exports = __webpack_public_path__ + "static/img/4_2_2.2d840191.jpg";